import React from "react";
import { FaUserTie } from "react-icons/fa";
import { FiCalendar } from "react-icons/fi";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import logoWhite from "../../assets/img/logo-white.png";
import logo from "../../assets/img/logo.png";
import Button from "../../components/Button";
const Lists = ({ item, editable }) => {
  const navigate = useNavigate();
  const theme = useSelector(state=>state.theme.theme);
  return (
    <div className="list_wrapper">
      <div className="list_content">
        <Link to={`/details/${item.plan_name}`}>
          <div className="plan_name">
            <h2>{item.plan_name}</h2>
            <img src={theme === "dark" ? logo : logoWhite} width="100%" alt="logo" />
          </div>
        </Link>
        <div className="list_item_body">
          <div className="date_user">
            <span>
              <FiCalendar /> <p>{item.date}</p>
            </span>
            <span className="author">
              <FaUserTie /> <p>Ganesh Pal</p>
            </span>
          </div>
          <div className="plan_name">
            <h2>{item.plan_name}</h2>
          </div>
          <div className="short_desc">
            {item.income_types.length > 0 && (
              <>
                <p>
                  {item.income_types.map((d, i) => (
                    <span
                      style={{ fontWeight: "500", fontSize: "14px" }}
                      key={i + 1}
                    >
                      {d.length > 75 ? d.substring(0, 72) + "..." : d},{" "}
                    </span>
                  ))}
                </p>
              </>
            )}
          </div>
          <div className="read_more_button">
            <span style={{flex: "1 0 0"}}>
              {/* <Link to={} className="glow neon">Read More</Link> */}
              <Button className="glow neon" onClick={()=>navigate(`/details/${item.plan_name}`)}>Read More</Button>
            </span>
            {editable && (
              <span>
                <Button className="glow neon edit_btn" onClick={()=>navigate(`/editplan/${item.plan_name}`)}>Edit Plan</Button>
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Lists;
